<div class="flex flex-col items-center w-full relative">
    <p 
        class="font-bold  grad-main-color text-transparent bg-clip-text self-start text-nowrap"
    > 
        {{ label }}
    </p>


    <round-progress
        [current]="getNum() "
        [max]="max"
        color="#0E6461"
        [radius]="radius" 
        [stroke]="stroke"
        [semicircle]="true"
        class="scale-50 2xl:scale-75"
      />
      <div class="flex flex-col absolute bottom-5"  >
        <p 
        class="grad-main-color bg-clip-text font-bold text-transparent text-base xl-plus:text-2xl"
        >
          {{ percentage ?? 0 }}%
        </p>

      </div>
      <div class="flex flex-col absolute bottom-2 2xl:bottom-[-0.5rem] 2xl:pt-3"  >

      <small class="text-gray-400 text-center w-full font-semibold" id="#baladyas"> {{selectedBaladyas.join('-')}} </small>
</div>


    <!-- <round-progress
        [current]=" getNum()"
        [max]="max"
        color="#0E6461"
        [radius]="radius"
        [stroke]="stroke"
        [semicircle]="true"
    />
    <div class="flex flex-col absolute bottom-5">
        <p
            class="grad-main-color bg-clip-text font-bold text-transparent text-2xl"
        >
            {{ percentage ?? 0 }}%
        </p>
    </div> -->

</div>